var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12.667px",
    height: "15.833px",
    viewBox: "0.979 0.427 12.667 15.833",
    enableBackground: "new 0.979 0.427 12.667 15.833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M4.517,9.383c-2.07,0.565-3.538,2.365-3.538,4.502v1.584c0,0.438,0.354,0.791,0.792,0.791h11.083 c0.438,0,0.793-0.354,0.793-0.791v-1.584c0-2.137-1.469-3.937-3.539-4.502c-0.177-0.049-0.352-0.026-0.52,0.049 C8.863,9.759,8.092,9.927,7.313,9.927c-0.78,0-1.551-0.168-2.276-0.495C4.869,9.356,4.694,9.334,4.517,9.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M7.313,0.427c-2.186,0-3.958,1.772-3.958,3.958c0,2.187,1.772,3.958,3.958,3.958 c2.186,0,3.959-1.772,3.959-3.958C11.271,2.199,9.498,0.427,7.313,0.427z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/ProfileUser.5f53c4c8e005eb138a05ffb5984d61b0.svg";
export { ForwardRef as ReactComponent };